import { render, staticRenderFns } from "./ImagemCarregavel.vue?vue&type=template&id=0f188918&scoped=true"
import script from "./ImagemCarregavel.vue?vue&type=script&lang=js"
export * from "./ImagemCarregavel.vue?vue&type=script&lang=js"
import style0 from "./ImagemCarregavel.vue?vue&type=style&index=0&id=0f188918&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f188918",
  null
  
)

export default component.exports